import { creatorbase } from '@round/api';
import styles from './UnallocatedCampaignsFilters.module.css';
import { StylesConfig } from 'react-select';
import { Select } from '@round/whitelabel-ui';
import { SearchInput } from '@round/whitelabel-ui';
import useTeamSelect from 'Modules/Plans/Team/hooks/useTeamSelect';
import { useUsersMultiSelect } from 'Modules/Plans/User/hooks/useUsersSelect';
import { mapStringListToArray } from 'helpers';
import { CheckboxFilter } from '@round/whitelabel-ui';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { financeStatusOptions } from '../FinanceStatusCell/helpers';

type FilterKeys = keyof Pick<
    creatorbase.GetCampaignsParams,
    'finance_status' | 'search' | 'team_id' | 'team_member_id' | 'exclude_fully_allocated'
>;
export type FilterValues = Partial<Record<FilterKeys, string | undefined>>;

type Props = {
    filters: FilterValues;
    onFiltersChange: (filters: FilterValues) => void;
};

const selectStyles: StylesConfig = {
    container: (base) => ({
        ...base,
        width: '18rem',
    }),
    control: (base) => ({
        ...base,
        height: '2.1875rem',
    }),
    option: (base) => ({
        ...base,
        color: '#242424',
    }),
    singleValue: (base) => ({
        ...base,
        color: '#242424',
    }),
};

const UnallocatedCampaignsFilters = ({ filters, onFiltersChange }: Props) => {
    const { selectedClientId } = useClientSelect();

    const { getProps: getTeamSelectProps } = useTeamSelect({
        initOn: 'menuOpen',
        initialValueId: filters.team_id ? Number(filters.team_id) : undefined,
        params: { client_id: selectedClientId },
        enabled: typeof selectedClientId === 'number',
    });

    const { getProps: getTeamMembersProps } = useUsersMultiSelect({
        initOn: 'menuOpen',
        initialValueIds: mapStringListToArray(filters.team_member_id).map(Number),
        params: { client_id: selectedClientId },
    });

    return (
        <div className={styles.container}>
            <SearchInput value={filters.search} onChange={(search) => onFiltersChange({ search: search.trim() })} />

            <Select
                options={financeStatusOptions}
                value={
                    financeStatusOptions.filter(
                        (option) => filters.finance_status?.split(',').includes(option.value)
                    ) ?? null
                }
                onChange={(values) => onFiltersChange({ finance_status: values?.map((v) => v.value).join(',') })}
                placeholder="Select status..."
                styles={selectStyles}
                isClearable
                isMulti
                isSearchable={false}
                hideSelectedOptions={false}
            />

            <Select
                {...getTeamSelectProps({
                    onChange: (o) =>
                        onFiltersChange({
                            team_id: o ? o.value.toString() : undefined,
                        }),
                })}
                placeholder="Select team..."
                isClearable
                styles={selectStyles}
            />

            <Select
                {...getTeamMembersProps({
                    onChange: (value) => onFiltersChange({ team_member_id: value?.map((v) => v.value).toString() }),
                })}
                placeholder="Select team members..."
                isClearable
                styles={selectStyles}
            />

            <CheckboxFilter
                value={filters.exclude_fully_allocated === 'true'}
                onChange={(value) => onFiltersChange({ exclude_fully_allocated: value ? 'true' : undefined })}
                className={styles.checkboxFilter}
            >
                Exclude fully allocated
            </CheckboxFilter>
        </div>
    );
};

export default UnallocatedCampaignsFilters;
